import { ThemeProvider } from '@mui/material/styles';
import { defaultTheme, fetchPortalFiles } from '../utilities/Utilites';
import * as React from 'react';
import Box from '@mui/system/Box';
import { Card, Grid, Link } from '@mui/material';
import { useGlobalStore } from '../utilities/GlobalState';
import { PortalFile } from '../interfaces/Interfaces';
import { Datagrid } from '../utilities/Datagrid';

export const QuotesPage = () => {
    const globalState = useGlobalStore((state) => state);
    const [quoteData, setQuoteData] = React.useState<Array<PortalFile>>();
    React.useEffect(() => {
        fetchPortalFiles(globalState.customerId, globalState?.authToken).then(
            (res) => {
                globalState.setPortalFiles(res.data);
                const cxRoles = globalState?.customerRoles
                    ?.slice(0, -1)
                    ?.split(',');
                const filteredData = res.data?.filter(
                    (item) =>
                        cxRoles?.includes(item?.type?.toUpperCase()) &&
                        item.category === 'QUOTATION',
                );
                setQuoteData(filteredData);
            },
        );
    }, []);

    const getRowId = (row: any) => {
        return row.document_id;
    };

    return (
        <ThemeProvider theme={defaultTheme}>
            <Box
                sx={{
                    padding: '30px 10px 10px 10px',
                    maxWidth: '100vp',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Card sx={{ padding: '10px', margin: '10px' }}>
                    <Grid
                        container
                        style={{
                            padding: '10px 10px 10px 20px',
                            backgroundColor: '#f44336',
                            color: '#fff',
                            fontWeight: 'bold',
                            fontSize: '20px',
                        }}
                    >
                        <Grid item>
                            <div>Pricing Information</div>
                        </Grid>
                    </Grid>

                    {Datagrid({
                        getRowId: getRowId,
                        pageSize: 20,
                        columns: [
                            {
                                field: 'document_id',
                                headerName: 'Document',
                                type: 'string',
                                flex: 0.15,
                            },
                            {
                                field: 'file_name',
                                headerName: 'File Name',
                                type: 'string',
                                flex: 0.25,
                            },
                            {
                                field: 'product',
                                headerName: 'Product',
                                type: 'string',
                                flex: 0.25,
                            },
                            {
                                field: 'revision',
                                headerName: 'Revision',
                                type: 'string',
                                flex: 0.15,
                            },
                            {
                                field: 'download_url',
                                headerName: 'Link',
                                type: 'string',
                                flex: 0.5,
                                renderCell: (params) => {
                                    return (
                                        <div>
                                            <Link
                                                target="_blank"
                                                href={params?.row?.download_url}
                                                rel="noreferrer"
                                            >
                                                {params?.row?.download_url}
                                            </Link>
                                        </div>
                                    );
                                },
                            },
                        ],
                        data: quoteData || [],
                    })}
                </Card>
            </Box>
        </ThemeProvider>
    );
};
